import classNames from "classnames";
import React from "react";
import { Trans } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";

import Exit from "components/icons/Exit";
import WarningYellowNotificationIcon from "components/icons/WarningYellowNotificationIcon";
import style from "components/tenants/tenant-trial-ending-banner.scss";
import { StoreState } from "store";

interface Props {
    days: number;
    visible: boolean;
    onDismiss: () => void;
}
const mapState = (state: StoreState) => ({
    theme: state.themeReducer.theme,
});
const connector = connect(mapState);

const TenantTrialEndingBanner = (props: ConnectedProps<typeof connector> & Props): JSX.Element => {
    const { days } = props;

    return props.visible ? (
        <>
            <div className={classNames(style.bannerContainer, { [style.neutral]: days < 0 })}>
                <WarningYellowNotificationIcon />
                <div className={classNames(style.bannerText)}>
                    {days < 0 ? (
                        <Trans i18nKey="CustomerProfile.trialTenantsNavPanel.trialEndedBannerText" />
                    ) : (
                        <Trans i18nKey="CustomerProfile.trialTenantsNavPanel.trialEndingText" count={days} />
                    )}
                </div>
                <div className={classNames(style.removeButtonContainer)}>
                    <button className={classNames(style.removeButton)} onClick={props.onDismiss}>
                        <Exit color={props.theme.iconFillColor} />
                    </button>
                </div>
            </div>
        </>
    ) : (
        <></>
    );
};
export default connector(TenantTrialEndingBanner);
